module.exports = __webpack_public_path__ + "static/media/integral.c2d6e291.jpg";